module.exports = __webpack_public_path__ + "img/28.e0ae5356.jpg";